import React from 'react';
import './Logo.css';
import DT_bubak from 'assets/img/DT_bubak.png';
import { NavLink } from 'react-router-dom';

const logo = () => {
  return (
    <div className="logo">
      <NavLink to="/" key="Hlavní stránka">
        <img src={DT_bubak} alt="logo Doktor Triceratops" />
      </NavLink>
    </div>
  );
}

export default logo;